import { useState } from "react";
import Navbar from "../../components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import ProblemSection from "./components/ProblemSection";
import SolutionSection from "./components/SolutionSection";
import CalculatorSection from "./components/CalculatorSection";
import ForWhomSection from "./components/ForWhomSection";
import CaseStudySection from "./components/CaseStudySection";
import HowItWorksSection from "./components/HowItWorksSection";
import TestimonialsSection from "./components/TestimonialsSection";
import PackagesSection from "./components/PackagesSection";
import FAQSection from "./components/FAQSection";
import FinalCTASection from "./components/FinalCTASection";
import FooterSection from "./components/FooterSection";
import ConsultationModal from "./components/ConsultationModal";

const Home = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <Navbar onOpenConsultation={() => setModalOpen(true)} />
      <main>
        <HeroSection onOpenConsultation={() => setModalOpen(true)} />
        <ProblemSection />
        <SolutionSection />
        <CalculatorSection />
        <ForWhomSection />
        <CaseStudySection />
        <HowItWorksSection />
        <TestimonialsSection />
        <PackagesSection onOpenConsultation={() => setModalOpen(true)} />
        <FAQSection />
        <FinalCTASection />
      </main>
      <FooterSection />
      <ConsultationModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />

      <a
        href="tel:+48509963499"
        className="fixed bottom-6 right-6 z-40 w-14 h-14 flex items-center justify-center rounded-full bg-[#1D4ED8] text-white hover:bg-[#1e40af] transition-colors cursor-pointer shadow-lg shadow-blue-500/30 lg:hidden"
        aria-label="Zadzwoń"
      >
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-phone-fill text-xl"></i>
        </div>
      </a>
    </div>
  );
};

export default Home;
